/**
 * @author Evgeny Shevtsov, info@sitespring.ru
 * @homepage http://sitespring.ru
 * @licence Proprietary
 */
import moment from "moment";
import ru from "moment/locale/ru";

moment.locale("ru");